import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { LinkItem, childRouteLinkItems } from '../child-routes';
import { filter, map, mergeMap } from 'rxjs/operators';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements OnInit {
    faHome = faHome;
    linkItems: LinkItem[];
    showPrintAlert: boolean = true;
    constructor(private router: Router, private route: ActivatedRoute) {
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            map(() => this.rootRoute(this.route)),
            filter((route: ActivatedRoute) => route.outlet === 'primary'),
            mergeMap((route: ActivatedRoute) => route.data)
        ).subscribe((data: { [name: string]: any }) => {
            var showPrintAlert = data.showPrintAlert;
            this.showPrintAlert = showPrintAlert != undefined ? showPrintAlert : true;
        });
    }

    ngOnInit() {
        this.linkItems = childRouteLinkItems;
    }

    private rootRoute(route: ActivatedRoute): ActivatedRoute {
        while (route.firstChild) {
            route = route.firstChild;
        }
        return route;
    }

    toggle(item: LinkItem) {
        item.collapse = !item.collapse
    }
}
